import { _ } from "libs";

/// <reference types="facebook-js-sdk" />

import React, { Component } from "react";
import loadScript from "../libs/loadScript";

type Props = {
	appId: string;
	onLogin: Function;
};

export default class FacebookLogin extends Component<Props> {
	componentDidMount() {
		if (window.FB) {
			const callback = () => {
				FB.init({
					appId: this.props.appId,
					autoLogAppEvents: true,
					xfbml: false, //won't parse social plugins
					version: "v3.1",
					status: true,
				});
			};

			loadScript("https://connect.facebook.net/en_US/sdk.js", "facebook-js").then(callback);
		}
	}

	onClick = () => {
		const authResponse = FB.getAuthResponse();

		console.log({ authResponse });

		if (authResponse) {
			this.props.onLogin(authResponse.accessToken);
			return;
		}

		FB.login(response => {
			if (response.authResponse) {
				this.props.onLogin(response.authResponse.accessToken);
			} else {
				console.log("User cancelled login or did not fully authorize.");
			}
		});
	};

	render() {
		return (
			<a onClick={this.onClick} className="link">
				{_("login.button.loginWithFacebook")}
			</a>
		);
	}
}
